var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlayPanLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 17,
    height: 17,
    rx: 1.5,
    fill: "#313131",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 17,
    height: 17,
    rx: 1.5,
    fill: "#313131",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H15",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7V15",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15L9.48284 15C9.30466 15 9.21543 15.2154 9.34142 15.3414L10.8586 16.8586C10.9367 16.9367 11.0633 16.9367 11.1414 16.8586L12.6586 15.3414C12.7846 15.2154 12.6953 15 12.5172 15L11 15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15L9.48284 15C9.30466 15 9.21543 15.2154 9.34142 15.3414L10.8586 16.8586C10.9367 16.9367 11.0633 16.9367 11.1414 16.8586L12.6586 15.3414C12.7846 15.2154 12.6953 15 12.5172 15L11 15Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11L15 12.5172C15 12.6953 15.2154 12.7846 15.3414 12.6586L16.8586 11.1414C16.9367 11.0633 16.9367 10.9367 16.8586 10.8586L15.3414 9.34142C15.2154 9.21543 15 9.30466 15 9.48284L15 11Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11L15 12.5172C15 12.6953 15.2154 12.7846 15.3414 12.6586L16.8586 11.1414C16.9367 11.0633 16.9367 10.9367 16.8586 10.8586L15.3414 9.34142C15.2154 9.21543 15 9.30466 15 9.48284L15 11Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L7 12.5172C7 12.6953 6.78457 12.7846 6.65858 12.6586L5.14142 11.1414C5.06332 11.0633 5.06332 10.9367 5.14142 10.8586L6.65858 9.34142C6.78457 9.21543 7 9.30466 7 9.48284L7 11Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L7 12.5172C7 12.6953 6.78457 12.7846 6.65858 12.6586L5.14142 11.1414C5.06332 11.0633 5.06332 10.9367 5.14142 10.8586L6.65858 9.34142C6.78457 9.21543 7 9.30466 7 9.48284L7 11Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7L9.48284 7C9.30466 7 9.21543 6.78457 9.34142 6.65858L10.8586 5.14142C10.9367 5.06332 11.0633 5.06332 11.1414 5.14142L12.6586 6.65858C12.7846 6.78457 12.6953 7 12.5172 7L11 7Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7L9.48284 7C9.30466 7 9.21543 6.78457 9.34142 6.65858L10.8586 5.14142C10.9367 5.06332 11.0633 5.06332 11.1414 5.14142L12.6586 6.65858C12.7846 6.78457 12.6953 7 12.5172 7L11 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayPanLock);
export default __webpack_public_path__ + "static/media/OverlayPanLock.081d4f976ba8b8204faa61a69e7fe492.svg";
export { ForwardRef as ReactComponent };